import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { BASEURL_POLYMER, SUB_PATH_BASIC } from '../../utils/api'
import { OutstandingLoanFee } from '../../models/polymer/OutstandingLoanFee.model'
interface QueryParams {
  hdb_ref: string
  uinfin: string
  singpass_token: string
}
export const outstandLoanApi = createApi({
  reducerPath: 'outstandLoanApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASEURL_POLYMER,
  prepareHeaders:(headers,{getState})=>{
    headers.set("Access-Control-Request-Method", "POST");
    headers.set("X-Content-Type-Options", "nosniff");
  }}),
  endpoints: (builder) => ({
    getOutstandinLoanByHdbRef: builder.query<OutstandingLoanFee, QueryParams>({
      query: (queryParams: QueryParams) => ({
        method: "POST",
        url:`${SUB_PATH_BASIC}/api/v1/hdb/pfs/checkOutstandingLoan`,
        body:{
          hdb_ref: queryParams.hdb_ref,
        },
        headers: {
          uinfin: queryParams.uinfin,
          Authorization: `Bearer ${queryParams.singpass_token}`
        },
      }),
      keepUnusedDataFor:1,
      transformResponse:(response: OutstandingLoanFee, meta, arg)=>{
        return response;
      }
    }),
   
  }),
})

export const { useGetOutstandinLoanByHdbRefQuery } = outstandLoanApi

